import { Grid, Typography } from '@mui/material';
import { SimpleShowLayout } from 'react-admin';

import { AccountOrderList } from '../../Orders/AccountOrderList';
import { AccountTransferList } from '../Summary/AccountTransferList';

import { AccountOfferOrderCardPaymentList } from './AccountOfferOrderCardPaymentList';
import { AccountOfferOrderList } from './AccountOfferOrderList';

export interface HistoryShowProps {
  accountId: number;
  accountNumber?: string;
}

export const HistoryShow = ({ accountId, accountNumber }: HistoryShowProps) => {
  return (
    <Grid container direction='row' spacing={2}>
      <Grid item xs={12}>
        <SimpleShowLayout>
          <Typography variant='h5'>Money Transfers</Typography>
        </SimpleShowLayout>
        <AccountTransferList accountId={accountId} accountNumber={accountNumber} />
      </Grid>
      <Grid item xs={12}>
        <SimpleShowLayout>
          <Typography variant='h5'>Card Payments</Typography>
        </SimpleShowLayout>
        <AccountOfferOrderCardPaymentList accountId={accountId} />
      </Grid>
      <Grid item xs={12}>
        <SimpleShowLayout>
          <Typography variant='h5'>Offer Orders</Typography>
        </SimpleShowLayout>
        <AccountOfferOrderList accountId={accountId} />
      </Grid>
      <Grid item xs={12}>
        <SimpleShowLayout>
          <Typography variant='h5'>Security Buy/Sell Orders</Typography>
        </SimpleShowLayout>
        <AccountOrderList accountId={accountId} />
      </Grid>
    </Grid>
  );
};
